// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3tGrq","additionalInfo":"AgreementModal_additionalInfo__28yeU"};